export default "__VITE_ASSET__C7L0tl9j__"